export enum CoordinatorErrors {
  LIMIT_NOT_FOUND = 'LIMIT_NOT_FOUND',
}
